(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    (() => {
    const formSelector = '.email-signup__form';
    const consentSelector = '.email-signup__consent-input';

    function resetConsent(root = document) {
      root.querySelectorAll(formSelector).forEach((form) => {
        const consent = form.querySelector(consentSelector);
        if (!consent) return;
        consent.checked = false;
        form.querySelector('.email-signup__button').disabled = true;
      });
    }

    document.addEventListener('change', (event) => {
      if (!event.target.matches(consentSelector)) return;
      event.target.closest(formSelector).querySelector('.email-signup__button').disabled = !event.target.checked;
    });

    document.addEventListener('submit', (event) => {
      if (!event.target.matches(formSelector)) return;
      const consent = event.target.querySelector(consentSelector);
      if (consent && !consent.checked) {
        event.preventDefault();
        consent.reportValidity();
      }
    }, true);

    document.addEventListener('reset', (event) => {
      if (!event.target.matches(formSelector)) return;
      queueMicrotask(() => resetConsent(event.target.parentElement));
    });

    window.addEventListener('pageshow', () => resetConsent());
    document.addEventListener('shopify:section:load', (event) => resetConsent(event.target));
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => resetConsent(), { once: true });
    } else {
      resetConsent();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
